import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { ACHIEVEMENT_TIERS } from '@didaskill/domain/user-achievements/constants';
import { Tag, type TagProps } from '@didaskill/ui/design-system';

import messages from './AchievementTierTag.messages';
import { TIER_TAG_VARIANTS_MAP } from './constants';

export type AchievementTierTagProps = {
  tier: ACHIEVEMENT_TIERS;
} & Exclude<TagProps, 'label' | 'variant'>;

const AchievementTierTagBase = ({ tier, ...props }: AchievementTierTagProps) => {
  if ([ACHIEVEMENT_TIERS.NEUTRAL, ACHIEVEMENT_TIERS.QUEST].includes(tier)) {
    return null;
  }

  return (
    <Tag
      label={<FormattedMessage {...messages[tier]} />}
      variant={TIER_TAG_VARIANTS_MAP[tier]}
      {...props}
    />
  );
};

export const AchievementTierTag = memo(AchievementTierTagBase);
